import { makeStyles } from 'tss-react/mui';
import { theme, colors } from '../../theme';

/**
 * Custom hook that defines the styles for the answer page component.
 */
const useAnswerPageStyles = makeStyles()(() => ({
  answerQuestionMeta: {
    fontFamily: theme.fontFamily,
    color: colors.gray['300'],
  },
  backContainer: {
    'display': 'flex',
    'alignItems': 'center',
    'color': theme.primary.dark,
    '&:hover': {
      cursor: 'pointer',
    },
    'margin': `${theme.margin.m} 0`,
  },
  awardViewsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
    minWidth: '200px',
    minHeight: '120px',
    height: '100%',
    alignItems: 'center',
    marginLeft: '15px',
  },
  ansButton: {
    fontFamily: theme.fontFamily,
    margin: `0 ${theme.margin.m}`,
  },
  questionInfo: {
    display: 'flex',
    minHeight: '120px',
  },
  questionSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 40px 10px 40px',
    boxShadow: `0 ${theme.boxShadowBorder} ${theme.boxShadowBorder} 0 ${theme.boxShadowColor}`,
    backgroundColor: theme.background.paper,
  },
  noAnswers: {
    fontSize: theme.fontSize.default,
    marginLeft: theme.margin.l,
    marginBottom: theme.margin.m,
  },
  commentSection: {
    margin: theme.margin.m,
    paddingRight: theme.padding.m,
  },
  questionBody: {
    display: 'flex',
    flexDirection: 'row',
    margin: `${theme.margin.m} 0`,
  },
  answerQuestionRow: {
    display: 'flex',
    flex: '1',
    justifyContent: 'center',
    margin: '0px 30px 0px 30px',
  },
  answerQuestionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '120px',
    height: '100%',
    width: '100%',
  },
  answerQuestionView: {
    width: '15%',
  },
  answerQuestionText: {
    fontFamily: theme.fontFamily,
    marginBottom: '10px',
  },
  answerQuestionRight: {
    'display': 'flex',
    'marginLeft': '5%',
    '&:hover': {
      cursor: 'pointer',
    },
    'width': '100%',
  },
  answerQuestionInfo: {
    display: 'flex',
    flexDirection: 'column',
  },
  answerQuestionTitle: {
    fontFamily: theme.fontFamily,
    marginBottom: '20px',
    textAlign: 'center',
  },
  voteUserContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '200px',
    minHeight: '120px',
    height: '100%',
  },
  ansAddHeader: {
    padding: `${theme.padding.s} 0 ${theme.padding.m} 2%`,
  },
  btns: {
    marginRight: '15%',
  },
  btn: {
    'fontFamily': theme.fontFamily,
    'borderRadius': '20px',
    'backgroundColor': theme.background.paper,
    'color': theme.text.primary.light,
    '&.Mui-selected': {
      'color': theme.text.primary.dark,
      'backgroundColor': theme.primary.light,
      '&:hover': {
        color: theme.text.primary.dark,
        backgroundColor: theme.primary.dark,
      },
      '&:active': {
        backgroundColor: theme.primary.darker,
        boxShadow: theme.buttonShadow(theme.primary.darker),
        color: theme.text.primary.dark,
      },
    },
    '&: active': {
      backgroundColor: theme.primary.darker,
      boxShadow: theme.buttonShadow(theme.primary.darker),
      color: theme.text.primary.dark,
    },
    'padding': '6px 16px', // Spacing around the button content
    'fontSize': '0.875rem',
  },
}));

export default useAnswerPageStyles;
